import { ISignificanceTableData } from '../../interfaces';
import useCacheLlmRawDataEffect from './useCacheLlmRawDataEffect';
import { useMemo } from 'react';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  analysisId: string;
  data: ISignificanceTableData;
}

const useCacheSignificanceLlmRawDataEffect = ({ analysisId, data }: IProps) => {
  const rawData = useMemo(() => {
    const { metricName, leadingVariant, control, variantA, variantB } = data;
    const ret = ['The raw data present on the report is this'];
    ret.push(`Metric name: ${metricName}`);
    if (control) {
      ret.push('Control group: ' + JSON.stringify(control));
    }
    if (variantA) {
      ret.push('Variant A: ' + JSON.stringify(variantA));
    }
    if (variantB) {
      ret.push('Variant B: ' + JSON.stringify(variantB));
    }
    switch (leadingVariant) {
      case 'variantA':
        ret.push('Variant A is leading');
        break;
      case 'variantB':
        ret.push('Variant B is leading');
        break;
      case undefined:
        break;
      default:
        throw new UnreachableCaseError(leadingVariant);
    }
    return ret.join('\n');
  }, [data]);
  useCacheLlmRawDataEffect({ analysisId, rawData });
};

export default useCacheSignificanceLlmRawDataEffect;
